export const SEARCH_PARAMS = {
  CIBO_LOCATION_ID: 'ciboLocationId',
  CHART: {
    DATE_RANGE_TYPE: 'dateRangeType',
    END_DATE: 'endDate'
  },
  CURRENT_PAGE: 'currentPage',
  DEVICE_VARIANT: 'deviceVariant',
  TABLE: {
    CURRENT_PAGE: 'currentPage',
    SORT_FIELD: 'sortField',
    SORT_ORDER: 'sortOrder'
  },
  DRAWER: {
    key: 'drawer',
    values: {
      ADD_IP_CAMERA: 'addIpCamera',
      ADD_USER: 'addUser',
      CIBO_LOCATION_DETAILS: 'ciboLocationDetails',
      CONFIGURE_SAMPLE_POINT: 'configureSamplePoint',
      DEVICES_FILTER: 'devicesFilter',
      IP_CAMERA_DETAILS: 'ipCameraDetails',
      SAMPLE_POINT_DETAILS: 'samplePointDetails'
    }
  },
  DRAWER_TAB: {
    key: 'drawerTab',
    values: {
      ABOUT: 'about',
      ALERT_TRIGGERS: 'alertTriggers',
      AUTOMATION: 'automation',
      DAM_SURVEY: 'damSurvey',
      GENERAL: 'general',
      OFFSET: 'offset'
    }
  },
  EVENT_ID: 'eventId',
  INVITATION_EMAIL: 'invitationEmail',
  PLAY_EVENT_AT_TIME: 'playEventAtTime',
  LAYER: {
    key: 'layer',
    values: {
      CIBO: 'cibo'
    }
  },
  MAP: {
    LAT: 'lat',
    LNG: 'lng',
    ZOOM: 'zoom'
  },
  SEARCH: 'search',
  SITE_ID: 'siteId', // TODO: @legacyLink Remove this line once we've implemented https://farmbot.atlassian.net/browse/FMBT-6879
  TAB: 'tab',
  UTM_TERM: 'utm_term'
};